import { atom } from "jotai";

export const cpsDataAtom = atom<any>(null);
